import AsyncStorage from '@react-native-async-storage/async-storage';
export const biometrics = {
  getBiometricLogin: async () => {
    return AsyncStorage.getItem('biometricLogin');
  },
  setBiometricLogin: async (enabled: boolean) => {
    if (enabled) {
      AsyncStorage.setItem('biometricLogin', 'true');
    } else {
      AsyncStorage.removeItem('biometricLogin');
    }
  },
  getUserAuthenticated: async () => {
    return AsyncStorage.getItem('userAuthenticated');
  },
  setUserAuthenticated: async (authenticated: boolean) => {
    if (authenticated) {
      AsyncStorage.setItem('userAuthenticated', 'true');
    } else {
      AsyncStorage.removeItem('userAuthenticated');
    }
  },
  setIsAuthenticating: async (authenticating: boolean) => {
    if (authenticating) {
      AsyncStorage.setItem('isAuthenticating', 'true');
    } else {
      AsyncStorage.removeItem('isAuthenticating');
    }
  },
  getIsAuthenticating: async () => {
    return AsyncStorage.getItem('isAuthenticating');
  },
  getBiometricAccessToken: async () => {
    return AsyncStorage.getItem('biometricUserAccessToken');
  },
  setBiometricAccessToken: async (accessToken: string) => {
    AsyncStorage.setItem('biometricUserAccessToken', accessToken);
  },
  removeBiometricAccessToken: async () => {
    AsyncStorage.removeItem('biometricUserAccessToken');
  }
};
export default biometrics;
